import { Pipe, PipeTransform } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { DomSanitizer, SafeUrl } from '@angular/platform-browser';
import { Observable, of } from 'rxjs';
import { map } from 'rxjs/operators';

/**
 * Return the SafeUrl obj for img[src], that Angular will let it display in UI
 * This Pipe will automatically download the image from server, or reading the File content for img[src] to display the img
 *
 * Ex: <img [src]="imgULR | showImg | async" />
 *
 * Ex: <img [src]="file | showImg | async" />
 *
 */
@Pipe({
  name: 'showImg',
})
export class ShowImagePipe implements PipeTransform {
  constructor(private http: HttpClient, private sanitizer: DomSanitizer) {}

  private sanitizerData(data: Blob | File): SafeUrl {
    // marked that IMGs's URL come from trusted sources, otherwise Angular will throw error "Unsafe"
    return this.sanitizer.bypassSecurityTrustUrl(URL.createObjectURL(data));
  }

  private getImgDataFromUrl(url: string): Observable<Blob> {
    return this.http.get(url, { responseType: 'blob' });
  }

  transform(value: string | File): Observable<SafeUrl> {
    // URL
    // For more information: https://stackoverflow.com/a/50463201
    if (typeof value === 'string') return this.getImgDataFromUrl(value).pipe(map(val => this.sanitizerData(val)));

    // Not URL, then it is File
    return of(this.sanitizerData(value));
  }
}
